module.exports = __webpack_public_path__ + "img/container.970c3e4d.svg";